import {Component, OnInit, ViewChild} from '@angular/core';
import {ClienteService} from "../services/cliente.service";
import {PedidoLoja} from "../objeto/PedidoLoja";
import {NgForm} from "@angular/forms";
import {CarrinhoService} from "../services/carrinho.service";
import {Location} from "@angular/common";
import {ITela} from "../objeto/ITela";
import {ConstantsService} from "../services/ConstantsService";
import {DominiosService} from "../services/dominios.service";
import {AutorizacaoLojaService} from "../services/autorizacao-loja.service";
import {ActivatedRoute} from "@angular/router";
import {MaskedTextBoxComponent} from "@progress/kendo-angular-inputs";

declare var fbq;

@Component({
  selector: 'app-loja-dados-cliente',
  templateUrl: './loja-dados-cliente.component.html',
  styleUrls: ['./loja-dados-cliente.component.scss']
})
export class LojaDadosClienteComponent implements OnInit, ITela {
  @ViewChild('frm')  frm: NgForm;
  @ViewChild('kendoMaskedTextBox', {static: false}) txtTelefone: MaskedTextBoxComponent;
  empresa: any;
  cliente: any = {};
  pedido: PedidoLoja;
  criarConta: boolean;
  informarDados: boolean;
  buscando: boolean;
  exibirSenha: boolean;
  informarCpf: boolean;
  cpfObrigatorio: boolean;
  informarCnpj: boolean;
  cnpjObrigatorio: boolean;
  informarDataNascimento: boolean;
  dataNascimentoObrigatorio: boolean;
  validandoEmail: boolean;
  emailExistente: boolean;
  erro: any;
  mensagem: string;
  fidelidadeExterna: any;
  target: string
  phoneMask: string;
  modoLeadCardapio: boolean;
  idProdutoLead: number;
  nomeProdutoLead: string;

  tiposDocumento = [
    { id: 'cpf', nome: 'CPF' },
    { id: 'cnpj', nome: 'CNPJ' }
  ];
  documentoSelecionado: any = this.tiposDocumento[0];

  constructor(private clienteService: ClienteService, private carrinhoService: CarrinhoService,
              private location: Location, private constantsService: ConstantsService,
              private autorizacao: AutorizacaoLojaService, private activatedRoute: ActivatedRoute,
              private dominiosService: DominiosService) { }

  ngOnInit() {
    this.modoLeadCardapio = this.activatedRoute.snapshot.queryParams.lead === '1';
    this.idProdutoLead = Number(this.activatedRoute.snapshot.queryParams.idProduto || 0) || null;
    this.nomeProdutoLead = this.activatedRoute.snapshot.queryParams.produto || '';
    this.pedido = this.carrinhoService.obtenhaPedido();
    this.cliente =  Object.assign({}, this.pedido.contato);
    this.target = this.activatedRoute.snapshot.queryParams.target;
    this.mensagem = this.activatedRoute.snapshot.queryParams.msg;

    if(this.cliente.naoIdentificado) this.cliente = {};

    this.constantsService.empresa$.subscribe( empresa => {
      if(!empresa) return;
      this.empresa = empresa;

      if(this.modoLeadCardapio){
        let usuario: any = this.autorizacao.getUsuario();
        if(usuario && usuario.id)
          this.cliente = Object.assign({}, usuario);
        if(!this.cliente.codigoPais)
          this.cliente.codigoPais = '+55';
        return;
      }

      if(this.empresa.integracaoFidelidade){
        this.fidelidadeExterna = Object.assign({},  this.empresa.integracaoFidelidade);
        this.fidelidadeExterna.aceitarFidelidade = false;
        this.fidelidadeExterna.optin = false;
      }
      let usuario: any = this.autorizacao.getUsuario();

      if(window.history.state.informarNomeCompleto){
        this.cliente.informarNomeCompleto = true;
        this.cliente.completarCadastro = true;
      } else {
        this.cliente.completarCadastro = usuario && (usuario.completarCadastro || usuario.informarCpf || usuario.informarDataNascimento);
      }

      if(usuario && usuario.id){
        this.criarConta = false;
        this.informarDados = this.cliente.completarCadastro || (this.empresa.integracaoFidelidade && !usuario.saldoFidelidade)
        if(this.informarDados){
          this.busqueContatoPeloTelefone();
        } else {
          return this.dominiosService.vaParaCarrinho();
        }
      } else {
        if(this.cliente.telefone)
          this.busqueContatoPeloTelefone()
      }

      if(!this.cliente.id){
        if(this.cliente.email && this.cliente.senha)
          this.criarConta = true;
        else if(this.cliente.telefone){
          this.informarDados = true;
        }
      }

    });

    this.constantsService.campoCpf$.subscribe( campoCpf => {
      if(this.modoLeadCardapio) return this.informarCpf = false;
      this.informarCpf = campoCpf != null;
      this.cpfObrigatorio = campoCpf && !campoCpf.opcional;
    });

    this.constantsService.campoCnpj$.subscribe( campoCnpj => {
      if(this.modoLeadCardapio) return this.informarCnpj = false;
      this.informarCnpj = campoCnpj != null;
      this.cnpjObrigatorio = campoCnpj && !campoCnpj.opcional;
    });

    this.constantsService.campoDataNascimento$.subscribe( campoDataNascimento => {
      if(this.modoLeadCardapio) return this.informarDataNascimento = false;
      this.informarDataNascimento = campoDataNascimento != null;
      this.dataNascimentoObrigatorio = campoDataNascimento && !campoDataNascimento.opcional;
    });

    if(this.cliente.cnpj)
      this.documentoSelecionado = this.tiposDocumento[1]


    if (typeof fbq !== 'undefined')
      fbq('track', 'Lead');

  }

  atualizarMeuCadastro(){
    if(this.modoLeadCardapio) return false;

    if(this.criarConta ) return false;

    if(this.cliente.requerAutenticacao) return false;

    if(this.cliente.completarCadastro || this.cliente.atualizarCadastro )
      return true;

    if(this.cliente.id && this.informarDados) return true;

    return false;
  }

  async continuarSemConta(){
    this.frm.onSubmit(null);
  }

  async onSubmit() {
    if( !this.frm.valid || this.validandoEmail)
      return;

    if(this.modoLeadCardapio)
      return this.salveLeadCardapio();

    let usuario = this.autorizacao.getUsuario();

    if(usuario && ( this.cliente.completarCadastro ||  this.informarDados)){
      usuario.nome = this.cliente.nome;
      usuario.cpf = this.cliente.cpf;
      usuario.email = this.cliente.email;
      usuario.dataNascimento = this.cliente.dataNascimento;
      this.autorizacao.salveUsuario(usuario);
    }

    await this.salveCliente();
  }

  private async salveLeadCardapio(){
    delete this.erro;
    this.buscando = true;

    let resposta: any = await this.clienteService.salveLeadCardapio({
      nome: this.cliente.nome,
      telefone: this.cliente.telefone,
      codigoPais: this.cliente.codigoPais || '+55',
      idProduto: this.idProdutoLead
    }).catch(erro => {
      this.erro = erro;
    });

    this.buscando = false;
    if(!resposta) return;

    if(resposta.contato)
      this.autorizacao.salveUsuario(resposta.contato);

    const numero = this.obtenhaNumeroWhatsappCaptacao();
    if(!numero){
      this.erro = 'WhatsApp da clínica não configurado';
      return;
    }

    window.location.href = this.obtenhaUrlWhatsappLead(numero);
  }

  private obtenhaUrlWhatsappLead(numero: string): string {
    return 'https://wa.me/' + numero + '?text=' +
      encodeURIComponent(this.monteMensagemInteresseProduto());
  }

  private monteMensagemInteresseProduto(): string {
    return 'Olá! Tenho interesse em saber mais sobre ' +
      (this.nomeProdutoLead || 'esse serviço') + '. Meu nome é ' + this.cliente.nome + '.';
  }

  private obtenhaNumeroWhatsappCaptacao(): string {
    let numero = String(this.empresa?.numeroWhatsapp?.whatsapp || this.empresa?.whatsapp || '').replace(/\D/g, '');
    if(numero && numero.length <= 11)
      numero = '55' + numero;

    return numero;
  }

  private async salveCliente(){
    delete  this.erro
    this.pedido.contato = this.cliente;

    if(this.fidelidadeExterna){
      if(this.fidelidadeExterna.optin && this.fidelidadeExterna.aceitarFidelidade &&
        this.fidelidadeExterna.id_cliente != null && !this.cliente.requerAutenticacao){
        this.pedido.fidelidadeGcom = { id_cliente: this.fidelidadeExterna.id_cliente}
      } else {
        delete   this.pedido.fidelidadeGcom
      }
    }

    if( this.cliente.atualizarCadastro){
      let erroAtualizar;
      this.buscando = true;
      await this.autorizacao.atualizeConta(this.cliente).catch( erro => {
        erroAtualizar = erro;
      })

      this.buscando = false;
      if(erroAtualizar) {
        this.erro = erroAtualizar;
        return;
      }
    }

    this.carrinhoService.salvePedido(this.pedido);

    if(!this.target)
      this.dominiosService.vaParaCarrinho();
    else
      this.dominiosService.navegueParaUrl(this.target)

  }


  async informouCpf(){
   await this.informouDocumento(this.cliente.cpf);
  }

  async informouCnpj(){
    await this.informouDocumento(this.cliente.cnpj, 'CNPJ');
  }

  async informouDocumento(documento: string, tipo = 'CPF'){
    if(this.cliente.id && !this.cliente.completarCadastro) return;

    this.buscando = true;
    let resposta: any = await this.clienteService.obtenhaCadastroCompletarPeloDocumento(documento, tipo).catch((e) => {
      console.error(e);
    });

    this.buscando = false;
    if (resposta && resposta.id) {
      if(this.cliente.id && this.cliente.id !== resposta.id){
        this.erro = `${tipo} já está em uso`
      } else {
        this.cliente.id = resposta.id;
        this.cliente.completarCadastro = true;
        this.criarConta = true;
      }
    }
  }

  busqueContatoPeloTelefone(){
    const telefoneConsultado = this.cliente.telefone;
    this.buscando = true;
    delete this.emailExistente;
    delete this.pedido.fidelidadeGcom;
    if(this.fidelidadeExterna){
      this.fidelidadeExterna.aceitarFidelidade = false;
      this.fidelidadeExterna.optin = false;
      delete this.fidelidadeExterna.id_cliente;
    }
    delete this.cliente.existe;
    delete this.cliente.temConta;
    delete this.cliente.requerAutenticacao;
    delete this.cliente.novo;

    this.clienteService.obtenhaClientePorTelefone(this.cliente.telefone).then( resposta => {
      if(this.cliente.telefone !== telefoneConsultado) return;

      this.buscando   = false;
      resposta = resposta || {};
      this.cliente.existe = resposta.existe === true;
      this.cliente.temConta = resposta.temConta === true;
      this.cliente.completarCadastro = resposta.completarCadastro === true;
      this.cliente.requerAutenticacao = resposta.requerAutenticacao === true;
      this.cliente.atualizarCadastro = !!this.cliente.id && this.cliente.completarCadastro;
      this.cliente.novo = !this.cliente.existe;

      if(resposta.fidelidadeExterna && resposta.fidelidadeExterna.id_cliente != null){
        this.fidelidadeExterna.aceitarFidelidade =
          resposta.fidelidadeExterna.aceitarFidelidade === true && !this.cliente.requerAutenticacao;
        this.fidelidadeExterna.id_cliente = resposta.fidelidadeExterna.id_cliente;
        if(!this.fidelidadeExterna.aceitarFidelidade)
          this.fidelidadeExterna.optin = false;
      }
    }).catch( () => {
      if(this.cliente.telefone === telefoneConsultado)
        this.buscando = false;
    })
  }

  informouTelefone() {
    if(this.modoLeadCardapio) return;

    if(this.cliente.id)
      this.cliente = { telefone: this.cliente.telefone,  nome: this.cliente.nome}

     this.busqueContatoPeloTelefone();
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu(){
    return false;
  }

  exibirCriarConta() {
    if(this.fidelidadeExterna && this.fidelidadeExterna.aceitarFidelidade &&
      !this.cliente.requerAutenticacao)
      this.fidelidadeExterna.optin = true;
    this.criarConta = true;
  }


  vaParaLogin(){
     this.dominiosService.vaParaLogin('cliente', this.cliente.telefone);
  }

  exibirSenhaTela() {
    this.exibirSenha = ! this.exibirSenha ;
  }

  valideEmail() {
    this.validandoEmail = true;
    this.clienteService.existeClienteComEmail(this.cliente.email).then( (existe: any) => {
        this.validandoEmail = false;
        this.emailExistente = existe;

    }).catch(() => {
      this.validandoEmail = false;
    })

  }

  canceleCriarConta() {
    this.criarConta = false;
  }

  escolheuNaoIndenficar() {
    this.cliente = {
      telefone: '00000000000',
      codigoPais: '+55',
      nome: 'Consumidor não identificado',
      naoIdentificado: true
    }
    this.salveCliente();
  }

  deveTerBordas() {
    return true;
  }

  deveExibirBannerTema() {
    return false;
  }

  alterouOptinFidelidade(){
    if(this.cliente.requerAutenticacao){
      this.fidelidadeExterna.optin = false;
      delete this.pedido.fidelidadeGcom;
      return;
    }

    if(!this.fidelidadeExterna.optin){
      delete this.pedido.fidelidadeGcom;
      if(!this.atualizarMeuCadastro())
        this.criarConta = false
      return;
    }

    if(!this.atualizarMeuCadastro())
      this.criarConta = true;
  }

  onPhoneMaskChange($event: string) {
    this.phoneMask = $event;
    if(this.txtTelefone)
      (this.txtTelefone as any).updateValue(this.txtTelefone.input.nativeElement.value);

  }

  onCountrySelected($event: string) {
    this.cliente.codigoPais = $event;
    console.log("setou código país. Contato: ", this.cliente)

  }

  trocarTipoDocumento(valor: any){
    // Limpa o outro campo
    if(this.documentoSelecionado.id === 'cpf') {
      this.cliente.cnpj = null;
    } else {
      this.cliente.cpf = null;
    }
  }

}
